import { useTranslation } from 'react-i18next';

import { GalleryImages } from './components/GalleryImages';
import { GalleryVideos } from './components/GalleryVideos';
import { EventImage } from './components/EventImage';

import { Root, Title } from './MediaContent.styles';
import { useAppSelector } from 'store/hooks';

const MediaContent = () => {
	const { t } = useTranslation();
	const { isPunchup } = useAppSelector((state) => state.auth);

	return (
		<Root>
			<Title isPunchup={isPunchup}>{t('website-media-content-title')}</Title>
			<EventImage />
			{!isPunchup && <GalleryImages />}
			{!isPunchup && <GalleryVideos />}
		</Root>
	);
};

export { MediaContent };
